
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_16mm3_869q5_5",
  "disabled": "awsui_disabled_16mm3_869q5_20",
  "expandable-header": "awsui_expandable-header_16mm3_869q5_24",
  "rolled-down": "awsui_rolled-down_16mm3_869q5_35",
  "highlighted": "awsui_highlighted_16mm3_869q5_38",
  "variant-navigation": "awsui_variant-navigation_16mm3_869q5_51",
  "category": "awsui_category_16mm3_869q5_63",
  "expandable": "awsui_expandable_16mm3_869q5_24",
  "expand-icon": "awsui_expand-icon_16mm3_869q5_84",
  "expand-icon-up": "awsui_expand-icon-up_16mm3_869q5_91",
  "expand-icon-right": "awsui_expand-icon-right_16mm3_869q5_94",
  "items-list-container": "awsui_items-list-container_16mm3_869q5_108"
};
  